import { useEffect, useRef, type ReactNode } from 'react'
import { useAuth } from '@/auth/useAuth'
import { startConnection, stopConnection } from '@/utils/signalR'

export function SignalRProvider({ children }: { children: ReactNode }) {
  const { session, status } = useAuth()
  const startedRef = useRef(false)

  // Start connection on login
  useEffect(() => {
    if (status !== 'authenticated' || !session?.bearerToken) return
    if (startedRef.current) return
    startedRef.current = true

    startConnection(session).catch(e => {
      console.error('[SignalRProvider] connection error:', e)
      startedRef.current = false
    })
  }, [status, session])

  // Stop connection on logout and reset the guard so re-login reconnects cleanly
  useEffect(() => {
    if (status !== 'unauthenticated') return
    startedRef.current = false
    stopConnection().catch(e => console.error('[SignalRProvider] stop error:', e))
  }, [status])

  return <>{children}</>
}
